module.exports = __webpack_public_path__ + "img/flower.88805054.svg";